import { Card, Divider } from "antd";

import ResetPasswordForm from "./components/resetPasswordForm";
import { styles } from "./styles/resetPasswordStyles";
import logo from "../../assets/images/airp_logo.png";
import dayjs from "../../config/dayjs";

export default function ResetPasswordPage() {
  return (
    <div style={styles.container}>
      <div style={{ width: "100%" }}>
        <div style={styles.logoContainer}>
          <img alt="logo" src={logo} style={styles.logo} />
        </div>
        <Card title="Reset Password" style={styles.resetPasswordCard}>
          <ResetPasswordForm />
          <Divider />
          <div style={styles.copyright}>© AIRP {dayjs().year()}</div>
        </Card>
      </div>
    </div>
  );
}
